module.exports = __webpack_public_path__ + "img/WitchDoctor.d1cc1bec.png";